import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import HomeView from "../views/home/index.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/about",
    name: "about",
    component: () => import("@/views/about.vue"),
  },
  {
    path: "/contact",
    name: "contact",
    component: () => import("@/views/contact.vue"),
  },
  {
    path: "/faq",
    name: "faq",
    component: () => import("@/views/faq.vue"),
  },
  {
    path: "/countries",
    name: "countries",
    component: () => import("../views/countries.vue"),
  },
  {
    path: "/workers",
    name: "workers",
    component: () => import("../views/workers.vue"),
  },
  {
    path: "/career",
    name: "career",
    component: () => import("../views/career.vue"),
  },
  // {
  //   path: "/services",
  //   name: "services",
  //   component: () => import("../views/services.vue"),
  // },
  // {
  //   path: "/workers/:nationalityId",
  //   name: "workers",
  //   component: () => import("../views/workers.vue"),
  // },
  // {
  //   path: "/request",
  //   name: "request",
  //   component: () => import("../views/request.vue"),
  // },
  // {
  //   path: "/checkRequest",
  //   name: "checkRequest",
  //   component: () => import("../views/checkRequest.vue"),
  // },
  // {
  //   path: "/request/:applicantId",
  //   name: "requestWithApplicant",
  //   component: () => import("../views/requestWithApplicant.vue"),
  // },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, from, next) => {
  next();

  // Scroll page to top on every route change
  window.scrollTo({
    top: 0,
    left: 0,
    behavior: "smooth",
  });
});

export default router;
